import {AppConfig} from '../../../../../lib/AppConfig';

export const WORKFORCE_PROFILES_IDS_QUERY_PARAM = 'wp_ids';

export const parseWorkforceProfilesIdsQueryParam = (value: string | undefined): string[] => {
  if (!value?.trim()) {
    return [];
  }

  return [...new Set(value.split(',').map((id) => id.trim()).filter(Boolean))];
};

export const buildWorkforceProfilesListFilterUrl = (profileIds: string[]): string => {
  const basePath = AppConfig.COMPANY_WORKFORCE_ANALYSIS_PROFILES_PATH;
  const ids = [...new Set(profileIds.filter(Boolean))];

  if (ids.length === 0) {
    return basePath;
  }

  return `${basePath}?${WORKFORCE_PROFILES_IDS_QUERY_PARAM}=${encodeURIComponent(ids.join(','))}`;
};
